import CommonLogin from './CommonLogin'
// import store from '../../../store'

CommonLogin.install = function (Vue, option = {}) {
  let container = document.createElement('div')
  document.body.appendChild(container)

  let $CommonLogin = Vue.extend(CommonLogin)
  let instance = new $CommonLogin({
    propsData: {
      ...option
    }
  }).$mount(container)
  Vue.prototype.$login = instance
}

export default CommonLogin
